import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ResultTable from "../../ExecuteLogics/ResultTable/ResultTable";
import DownloadRounded from "@mui/icons-material/DownloadRounded";
import { GlobalState } from "context/GlobalContext";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
import { getFileSignedUrl } from "components/ReplenishmentDashboard/data";
import { Box } from "@mui/material";

const ResultsTab = ({ fullData = {}, resultKey = "result", setResultData, resultData = {} }) => {
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();

	if (typeof resultData === "object" && Object.keys(resultData)?.length > 0) {
		const summary = resultData?.summary;
		const handleDownloadClick = async () => {
			setLoadingOpen(true);

			try {
				const fileUrl = await getFileSignedUrl(resultData?.file_path);
				window.open(fileUrl, "_blank");
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrMsgFromError(error), severity: "error" });
				setLoadingOpen(false);
			}
		};
		return (
			<Stack sx={{ width: "100%" }}>
				<Box pb={1}>
					<Button startIcon={<DownloadRounded />} onClick={handleDownloadClick} variant="contained" size="small">
						Download
					</Button>
				</Box>
				{Array.isArray(summary) ? (
					<ResultTable tableRows={summary} />
				) : (
					<Typography variant="body1">No Summary Data to Display.</Typography>
				)}
			</Stack>
		);
	} else
		return (
			<>
				<Typography variant="body1">Result will be shown here.</Typography>
			</>
		);
};

export default ResultsTab;
